<template>
    <div id="browse">
        <Navi currentPage="3"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Results</el-breadcrumb-item>
                    <el-breadcrumb-item>Phenotypes</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div v-if="loading" class="pcga-loading">
                <el-row
                    v-loading="true"
                    element-loading-background="rgba(255, 255, 255, 1)"
                    style="height:100%"
                ></el-row>
                <!-- <pcga-loading></pcga-loading> -->
            </div>
            <div v-if="!loading">
                <div class="results" v-if="!error_page">
                    <div class="task_results">
                        <el-collapse v-model="activeCollapse1">
                            <el-collapse-item name="1">
                                <template slot="title">
                                    <i class="header-icon el-icon-info"></i> Summary of phenotype GWAS
                                </template>
                                <el-descriptions class="margin-top" :column="3" border>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-user"></i>
                                            Phenotype ID
                                        </template>
                                        {{ pheno_meta.id }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-mobile-phone"></i>
                                            Phenotype name
                                        </template>
                                        {{ pheno_meta.trait }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-location-outline"></i>
                                            MeSH term
                                        </template>
                                        <el-tag size="middle" type="success">
                                            <el-link
                                                :href="'https://www.ncbi.nlm.nih.gov/mesh/' + pheno_meta.mesh_id"
                                                target="_blank"
                                            >{{ pheno_meta.mesh_term }}</el-link>
                                        </el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Sample size
                                        </template>
                                        {{ pheno_meta.sample_size }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Population
                                        </template>
                                        <el-tag size="middle">{{ pheno_meta.population }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Category
                                        </template>
                                        {{ pheno_meta.category }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            PubMed ID
                                        </template>
                                        <el-tag size="middle" type="success">
                                            <el-link
                                                :href="'https://pubmed.ncbi.nlm.nih.gov/' + pheno_meta.pmid"
                                                target="_blank"
                                            >{{ pheno_meta.pmid }}</el-link>
                                        </el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            URL
                                        </template>
                                        <el-link
                                            :href="pheno_meta.doc"
                                            target="_blank"
                                        >{{ pheno_meta.doc }}</el-link>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-collapse-item>
                        
                    
                        <el-collapse-item name="2">
                                <template slot="title">
                                    <i class="header-icon el-icon-info"></i> Associated genes and tissue/cell types
                                </template>
                        <el-tabs type="border-card" @tab-click="switchRNAdb" v-model="active_RNAdb">
                            <el-tab-pane
                                v-for="db of rna_db"
                                :key="db.id"
                                :label="db.label"
                                :name="db.id"
                            ></el-tab-pane>
                                <div class="context_main_body">
                                    <el-collapse v-model="activeCollapse2">
                                        <el-collapse-item  name="2">
                                            <template slot="title">
                                                <i class="header-icon el-icon-info"></i> Associated tissues/cell types
                                            </template>
                                            <div
                                                class="pcga-result-des"
                                            >Here are associated tissues/cell types with P &lt; 0.05. The significance in pie plot is Bonferroni family-wise error rate (FWER) &lt; 0.05.</div>
                                            <div class="pcga-result-table-box pcga-result-box">
                                                <div>
                                                    <CellTab
                                                        :table_data="cell_table_data"
                                                        :loading="cell_table_data.loading"
                                                        :loadData="loadCellData"
                                                        :showRate="true"
                                                    ></CellTab>
                                                </div>
                                            </div>
                                            <div class="pcga-result-fig-box pcga-result-box" v-if="!cell_box_data.empty">
                                                <div class="pcga-result-fig1-box">
                                                    <Box
                                                        :fig_data="cell_box_data"
                                                        :loading="cell_box_data.loading"
                                                        :empty="cell_box_data.empty"
                                                    ></Box>
                                                    <Pie
                                                        :fig_data="cell_pie_data"
                                                        :loading="cell_pie_data.loading"
                                                        :empty="cell_pie_data.empty"
                                                    ></Pie>
                                                </div>
                                            </div>
                                        </el-collapse-item>
                                        <el-collapse-item name="1">
                                            <template slot="title">
                                                <i class="header-icon el-icon-info"></i> Associated genes
                                            </template>
                                            <div
                                                class="pcga-result-des"
                                            >Here are conditionally associated genes (FDR q-value &lt; 0.1).</div>
                                            <div class="pcga-result-table-box pcga-result-box">
                                                <div>
                                                    <Tab
                                                        :table_data="gene_table_data"
                                                        :loading="gene_table_data.loading"
                                                        :loadData="loadGeneData"
                                                    ></Tab>
                                                </div>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                        </el-tabs>
                        </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
                <div class="results" v-else>
                    <el-result icon="error" title="Invalid link" :subTitle="error_msg"></el-result>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Navi from "@/components/navigate.vue";
import Footer from "@/components/footer.vue";
import Tab from "@/components/plot/common_table.vue";
import CellTab from "@/components/plot/cell_table.vue";
import Box from "@/components/plot/box.vue";
import Pie from "@/components/plot/pie.vue";
import axios from "axios/dist/axios.min";
import { api_dir,echartTable2vxeTable } from "@/bus.js";
export default {
    name: "browse",
    components: { Navi, Footer, Tab, Box, Pie,CellTab },
    data: function () {
        return {
            activeCollapse1:['1','2'],
            activeCollapse2:['1','2'],
            error_page: false,
            loading: true,
            id: '',
            error_msg: "The url doesn't contain phenotype ID!",
            rna_db: [
                { 'id': 'gtex', 'label': 'Human tissues' },
                { 'id': 'sc_hs', 'label': 'Human single cell types' },
                { 'id': 'sc_mm', 'label': 'Mouse single cell types' }
            ],
            active_RNAdb: 'gtex',
            tabelData: [],
            loading1: false,
            cols: [],

            gene_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "CondiECSP", order: "asc" } },
                tableColumn: [
                    { field: 'Gene', title: 'Gene symbol', width: '18%', msg: { message: 'Gene symbol in HGNC' }, sort: true },
                    { field: 'Chromosome', title: 'Chromosome', width: '17%', msg: { message: 'Chromosome loci' }, sort: true },
                    { field:  '#Var', title: 'Number of SNPs', width: '15%', msg: { message: 'Number of SNPs included in gene for gene based association test' }, sort: true },
                    // { field: 'Group', title: 'Group', width: '10%', msg: { message: 'LD group ID of genes in conditional gene based analysis step' }, sort: true },
                    { field: 'ECSP', title: 'ECS P-value', width: '15%', msg: { message: 'Gene based association P-value calculated by ECS (effective chi-square), see details in [Help-Framework]' }, sort: true },
                    { field: 'CondiECSP', title: 'Conditional P-value', width: '20%', msg: { message: 'Conditional gene based association P-value, see details in [Help-Framework]' }, sort: true },
                    {
                        field: 'GeneScore', title: 'Gene score', width: '15%', msg: {
                            message: 'Gene score for determining the order that genes enter the conditional analysis step \
                    , see details in [Help-Framework]' }, sort: true
                    },
                ],
                tableData: [],
            },
            cell_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "p", order: "asc" } },
                tableColumn: [
                    { field: 'cell_type_id', title: 'Tissue/cell type ID', width: '28%', msg: { message: 'Tissue/single cell type ID' }, sort: true },
                    { field: 'cell_type', title: 'Tissue/cell type name', width: '18%', msg: { message: 'Tissue/single cell type name' }, sort: true },
                    { field: 'category_cell_type', title: 'Category', width: '17%', msg: { message: 'Category of tissues/cell types' }, sort: true },
                    { field: 'source', title: 'Source organ', width: '17%', msg: { message: 'Organ where the tissue/single cell type sampling' }, sort: true },
                    { field: 'p', title: 'P-value', width: '10%', msg: { message: 'P-value of association between tissue/cell type and phenotype' }, sort: true },
                ],
                tableData: [],
            },

            cell_box_data: {
                loading: true,
                width: "550px",
                height: "400px",
                plot_data: {
                    data: [],
                    val_col: '',
                    cate_col: '',
                    detail_cols: [],
                    title: '-log10(p) of associated tissues/cell types',
                },
                empty:false
            },
            cell_pie_data: {
                loading: true,
                width: "600px",
                height: "400px",
                plot_data: {
                    data: [],
                    title: 'Categories of significant tissues/cell types',
                },
                empty:false
            },
            pheno_meta:{
                
            }
        };
    },
    created:function(){
        this.getTaskID();
    },
    mounted: function () {
        // this.getTaskID();
        this.loadMetaData();
        this.loadGeneData();
        this.loadCellData();
    },

    methods: {
        getTaskID() {
            if ('id' in this.$route.query) {
                this.id = this.$route.query.id;
            } else {
                _this.error_page = true;
            }
        },
        loadMetaData() {
            var _this = this
            var para = { 'action': 'search_phenotype', 'id': this.id }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    _this.pheno_meta = res[0];
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadGeneData() {
            var _this = this
            _this.gene_table_data.loading = true;
            var para = {
                'action': 'phenotype_assoc_gene_full',
                'phenotype_id': this.id,
                'type': this.active_RNAdb
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    //do table
                    let table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['Gene']='<a target="_blank" class="table_a" href="#/results/gene?id='+s['Gene']+'">'+s['Gene']+'</a>'
                    }
                    _this.gene_table_data.tableData=table_data;
                    _this.gene_table_data.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadCellData() {
            var _this = this
            _this.cell_box_data.loading = true;
            _this.cell_pie_data.loading = true;
            _this.cell_table_data.loading = true;
            _this.cell_box_data.empty = false;
            _this.cell_pie_data.empty = false;
            var para = {
                'action': 'phenotype_assoc_cell_full',
                'phenotype_id': this.id,
                'type': this.active_RNAdb
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    //do table
                    let table_data = echartTable2vxeTable(res);
                    if(res.length==0){
                        _this.cell_box_data.empty = true;
                        _this.cell_pie_data.empty = true;
                        _this.cell_box_data.loading = false;
                        _this.cell_pie_data.loading = false;
                        _this.cell_table_data.tableData=table_data;
                        _this.cell_table_data.loading = false;
                        return
                    }

                    for(var s of table_data){
                        s['cell_type_id']='<a target="_blank" class="table_a" href="#/results/cell?id='+s['cell_type_id']+'">'+s['cell_type_id']+'</a>'
                        if(s['p']<0.01/s['count']){
                            s['rate']=3
                        }else if(s['p']<0.05/s['count']){
                            s['rate']=2
                        }else if(s['p']<0.05){
                            s['rate']=1
                        }
                    }
                    _this.cell_table_data.tableData=table_data;
                    _this.cell_table_data.loading = false;
                    //do figure
                    for (var i = 1; i < res.length; i++) {
                        res[i][0] = -Math.log10(res[i][0]);
                    }
                    var switch_name = {
                        'p': '-log10(P-value)',
                        'cell_type_id': 'Tissue/Cell type ID',
                        "cell_type": "Tissue/Cell type",
                        "category_cell_type": "Category",
                        'count':'count'
                    }
                    for (var i = 0; i < res[0].length; i++) {
                        res[0][i] = switch_name[res[0][i]];
                    }
                    _this.cell_box_data.plot_data.data = res;
                    _this.cell_box_data.plot_data.val_col = '-log10(P-value)';
                    _this.cell_box_data.plot_data.cate_col = 'Category';
                    _this.cell_box_data.plot_data.name_col = 'Tissue/Cell type ID';
                    _this.cell_box_data.plot_data.detail_cols = ['Tissue/Cell type ID', 'Tissue/Cell type', 'Category', '-log10(P-value)'];
                    _this.cell_box_data.plot_data.mark_val=-Math.log10(0.05/(res.length-1));
                    _this.cell_box_data.loading = false;
                    var category_idx = res[0].indexOf('Category');
                    var p_idx = res[0].indexOf('-log10(P-value)');
                    var count_idx = res[0].indexOf('count');
                    var k = 0;
                    var map_val = {};
                    for (var i = 1; i < res.length; i++) {
                        var pcut= -Math.log10(0.05 / (res[i][count_idx]));
                        if (res[i][p_idx] >= pcut) {
                            if (!(res[i][category_idx] in map_val)) {
                                map_val[res[i][category_idx]] = 0;
                            }
                            map_val[res[i][category_idx]] += 1;
                        }
                    }
                    var pdata = []
                    for (var x in map_val) {
                        pdata.push({ name: x, value: map_val[x] });
                    }
                    // console.log(pdata)
                    _this.cell_pie_data.plot_data.data = pdata;
                    _this.cell_pie_data.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        handleGenePageChange({ currentPage, pageSize }) {
            this.genePage.currentPage = currentPage;
            this.genePage.pageSize = pageSize;
            this.loadGeneData();
        },
        handleCellPageChange({ currentPage, pageSize }) {
            this.cellPage.currentPage = currentPage;
            this.cellPage.pageSize = pageSize;
            this.loadCellData();
        },

        switchRNAdb(tab) {
            this.active_RNAdb = tab.name;
            this.loadGeneData();
            this.loadCellData();
        }

    },
};
</script>



<style>
.el-collapse-item__header {
    font-size: 16px;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/results/phenotype.vue